import { render, staticRenderFns } from "./Vagas.vue?vue&type=template&id=773f3614"
import script from "./Vagas.vue?vue&type=script&lang=js"
export * from "./Vagas.vue?vue&type=script&lang=js"
import style0 from "./Vagas.vue?vue&type=style&index=0&id=773f3614&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports